// Shared configuration for the application
// REACT_APP_BACKEND_URL must be set in .env file

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL  || "http://localhost:5000";

if (!BACKEND_URL) {
  console.error('REACT_APP_BACKEND_URL environment variable is not set');
}
